import { Injectable } from '@angular/core';
import { Resource } from '@df/catalog/resource';
import { SeeRangeInStore } from './see-range-in-store';
declare module '@df/catalog/resource' {
    interface IResources {
        seeRangeInSTore: Resource<SeeRangeInStore, string>;
    }
}
@Injectable({
    providedIn: 'root'
})
export class SeeRangeInStoreResource extends Resource<SeeRangeInStore, string> {
    static override instance = SeeRangeInStore;
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = true;
}
